import { lt } from '@mews/framework';
import { Body, Button, Dialog, Stack } from '@optimus-web/core';

interface DisableGoLiveDialog {
    active: boolean;
    loading: boolean;
    onCancel: () => void;
    onConfirm: (goLive: boolean) => void;
}

export const DisableGoLiveDialog = ({ active, onCancel, onConfirm, loading }: DisableGoLiveDialog) => (
    <Dialog
        active={active}
        loading={loading}
        onClose={onCancel}
        size="small"
        title={lt('OnboardingGoLiveDisableHeader')}
    >
        <Stack spacing="300" vertical>
            <Body variant="secondary">{lt('OnboardingGoLiveDisableBody')}</Body>
            <Stack distribution="space-between">
                <Button onClick={onCancel} type="submit">
                    {lt('Cancel')}
                </Button>
                <Button variant="destructive" onClick={() => onConfirm(false)} type="submit">
                    {lt('OnboardingGoLiveDisableButton')}
                </Button>
            </Stack>
        </Stack>
    </Dialog>
);
